export enum IndustryCodeEnum {
  personal = 'personal',
  designer = 'designer',
  bar_restaurant = 'bar_restaurant',
  cafe_bakery = 'cafe_bakery',
  retail = 'retail',
  hotel = 'hotel',
}
